"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityLogSchemaProperties = exports.ActivityLogSchema = exports.ResourceTypeEnum = exports.ActorTypeEnum = exports.ActivityActionEnum = void 0;
const zod_1 = require("zod");
const schema_properties_interface_1 = require("./schema-properties-interface");
const ActivityActionEnum = zod_1.z.enum([
    "create",
    "update",
    "overwrite",
    "delete",
    "read",
    "relate",
    "unrelate",
    "archive",
    "unarchive",
    "cancel",
    "reverse_cancel",
    "reschedule",
    "complete",
    "outcome_updated",
    "inactivate",
    "reactivate",
    "assign",
    "unassign",
    "pause",
    "resume",
    "approve",
    "unapprove",
    "intent",
    "sync-failed",
    "charged_payment",
    "email_sent",
    "sms_sent",
]);
exports.ActivityActionEnum = ActivityActionEnum;
exports.ActorTypeEnum = zod_1.z.enum([
    "organization",
    "account",
    "client",
    "robot",
    "agent",
]);
exports.ResourceTypeEnum = zod_1.z.enum([
    "account",
    "organization",
    "file",
    "folder",
    "client",
    "appointment",
    "scheduler",
    "availability",
    "invoice",
    "product",
    "package",
    "message",
    "smartaction",
    "note",
    "form",
    "session-billing",
    "billing-rate",
    "workflow",
    "subscription",
]);
exports.ActivityLogSchema = zod_1.z.object({
    id: zod_1.z.string(),
    timestamp: zod_1.z.date(),
    requestId: zod_1.z.string().optional(),
    action: ActivityActionEnum,
    actorId: zod_1.z.string(),
    actorType: exports.ActorTypeEnum,
    resourceId: zod_1.z.string(),
    resourceType: exports.ResourceTypeEnum,
    organizationId: zod_1.z.string(),
    clientId: zod_1.z.string().optional(),
    data: zod_1.z.object({}).passthrough().optional(),
    resolved: zod_1.z
        .object({
        resolvedAt: zod_1.z.date().optional(),
        resolvedBy: zod_1.z.string().optional(),
    })
        .optional()
        .nullable(),
});
exports.ActivityLogSchemaProperties = {
    collectionName: "activityLog",
    deleteMode: schema_properties_interface_1.DeleteMode.None,
};
//# sourceMappingURL=activity-log-schema.js.map